$(function () {
  if (!customElements.get('member-tasks')) {
    customElements.define(
      'member-tasks',
      class memberTasks extends HTMLElement {
        constructor() {
          super();
          window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
          this.modalManager = window.litime.ModalControllerState;
          this.container = null;
          this.token =
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjkwMDAwMTY4MywiYWNjZXNzIjoiYWNjZXNzIiwiZXhwIjoxOTAwODA4NTgyfQ.6hdmN-fLW-pOBoQQsGn1DO2JmV8odkekYh2_aH4Rwak';
        }
        connectedCallback() {
          this.initTasks();
        }

        // 获取兑换列表
        async getMemberRedeem(data) {
          const url = '/shopify/point-task/page';
          const res = await window.litime.http.get(url, {
            data,
          });
          if (res.code === 200) {
            return res.data;
          } else {
            throw new Error(window.i18n.error_message_timeout);
          }
        }

        async completePointTask(id) {
          const url = `/shopify/user/point/task/${id}`;
          const res = await window.litime.http.post(url);
          if (res.code === 200) {
            return res.data;
          } else {
            throw new Error(window.i18n.error_message_timeout);
          }
        }

        async doTask(id, taskType, url = '') {
          console.log('doTask', id, taskType, url);
          switch (taskType) {
            case 1:
              window.litime.eventBus.publish('REGISTER');
              break;
            case 2:
              const footer = document.querySelector('main-footer');
              if (footer) {
                const input = footer.querySelector('input[name="contact[email]"]');
                if (input) input.focus();
              }
              break;
            case 3:
              window.location.href = '/account?type=profile';
              break;
            case 4:
              window.location.href = '/';
              break;
            case 5:
              window.location.href = '/pages/register-warranty';
              break;
            case 6:
              window.location.href = '/pages/all-reviews';
              break;
            case 22:
              window.location.href = '/account?type=profile';
              break;
            default:
              if (url) {
                try {
                  const res = await this.completePointTask(id);
                  if (isCompleted) {
                    this.hasTaskCompleted(id);
                  }
                  window.litime.eventBus.publish('CHANGE_USER_POINTS_DATA', res);
                } catch (error) {}

                let openUrl = url;
                if (taskType == 11) {
                  openUrl = `https://www.instagram.com/share?url=${encodeURIComponent(url)}`;
                } else if (taskType == 12) {
                  openUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
                } else {
                }
                window.open(openUrl, '_blank');
                // 刷新页面
                window.location.reload();
              }
              break;
          }
        }

        hasTaskCompleted(id) {
          const taskDom = $(`[data-taskId="${id}"]`);
          const completedDom = taskDom.find('.member-tasks-btn-completed');
          const btnWrapper = taskDom.find('.member-tasks-btn-wrapper');
          if (completedDom.length > 0) {
            completedDom.removeClass('hidden').addClass('flex');
            btnWrapper.addClass('hidden');
          }
        }

        async initTasks() {
          try {
            const res = await this.getMemberRedeem({
              page: 1,
              pageSize: 999,
            });

            // 获取浏览器宽度
            const browserWidth = window.innerWidth;
            let size;
            if (browserWidth < 768 && browserWidth > 576) {
              size = 4;
            } else {
              size = 6;
            }

            const memberTasksSwiper = $(this.querySelector('.member-tasks-swiper'));
            const swiperWrapper = memberTasksSwiper.find('.swiper-wrapper');
            const swiperSlides = memberTasksSwiper.find('.swiper-slide');
            const swiperSlidesCopy = swiperSlides.first().clone();
            swiperWrapper.empty();
            const slideCount = Math.ceil(res.records.length / size);
            for (let i = 0; i < slideCount; i++) {
              const swiperSlide = swiperSlidesCopy.clone();
              const slideWrapper = swiperSlide.find('.slide_wrapper');
              const slideItemCopy = slideWrapper.find('.slide_item').first().clone();
              slideWrapper.empty();
              for (let j = 0; j < size; j++) {
                const slideItem = slideItemCopy.clone();
                const item = res.records[j + i * size];
                if (!item) continue;
                slideItem.attr('data-taskType', item?.taskType);
                slideItem.attr('data-taskId', item.id);
                slideItem.find('.member-tasks-img').attr('src', item.icon);
                slideItem.find('.member-tasks-title').text(item.taskName);
                if (item.taskType === 4) {
                  const pointPerDollar = slideItem.find('.member-tasks-points').attr('data-type-4');
                  const totalPoints = item.point * item.multiple;
                  const dollarVal = item.ext?.amountRange ?? '';
                  let text = pointPerDollar
                    .replace(/\{\{\s*points\s*\}\}/g, String(totalPoints))
                    .replace(/\{\{\s*dollar\s*\}\}/g, String(dollarVal));
                  if (totalPoints <= 1) {
                    // 动态：任意以 s 结尾的单词去掉末尾 s（适配多语言）
                    text = text.replace(/\b(\w+)s\b/gi, '$1');
                  }
                  slideItem.find('.member-tasks-points').html(text);
                } else if (item.taskType === 17) {
                  if (item.point == 0) {
                    slideItem.find('.member-tasks-points').text(item.taskDesc || '');
                  } else {
                    slideItem.find('.member-tasks-points').find('span').text(item.point);
                  }
                } else {
                  slideItem.find('.member-tasks-points').find('span').text(item.point);
                }
                if (item.tag) {
                  slideItem.find('.member-tasks-tags').removeClass('hidden');
                  slideItem.find('.member-tasks-tags').text(item.tag);
                  slideItem.addClass('pt-[50px]');
                } else {
                  slideItem.find('.member-tasks-tags').addClass('hidden');
                  slideItem.removeClass('pt-[50px]');
                }
                if (item.isCompleted) {
                  slideItem.find('.member-tasks-btn-wrapper').addClass('hidden');
                  slideItem.find('.member-tasks-btn-completed').removeClass('hidden').addClass('flex');
                } else {
                  slideItem.find('.member-tasks-btn-wrapper').removeClass('hidden');
                  slideItem.find('.member-tasks-btn-completed').addClass('hidden');
                }
                const btn = slideItem.find('.member-tasks-btn');
                btn.on('click', () => {
                  if (window.customer) {
                    if (item?.ext?.shareLinkUrl || item?.ext?.socialMediaLink) {
                      this.doTask(item.id, item.taskType, item?.ext?.shareLinkUrl || item?.ext?.socialMediaLink);
                    } else {
                      this.doTask(item.id, item.taskType);
                    }
                  } else {
                    if (item.taskType === 1) {
                      window.litime.eventBus.publish('REGISTER');
                    } else {
                      window.litime.eventBus.publish('LOGIN');
                    }
                  }
                });
                slideWrapper.append(slideItem);
              }
              swiperWrapper.append(swiperSlide);
            }
            swiperWrapper.addClass('flex').removeClass('hidden');
            if (res.records.length <= 6) {
              memberTasksSwiper.find('.member-tasks-swiper-btns').addClass('hidden');
            } else {
              memberTasksSwiper.find('.member-tasks-swiper-btns').removeClass('hidden');
            }
            if (res.records.length === 0) {
              $(this.querySelector('.member-task-empty')).removeClass('hidden');
            }
            this.init();
          } catch (error) {
            if (window.litime?.showToast) {
              window.litime.showToast('error', error.message);
            }
            const memberTaskEmpty = $(this.querySelector('.member-task-empty'));
            memberTaskEmpty.removeClass('hidden');
          }
        }

        init() {
          const memberTasksSwiper = this.querySelector('.member-tasks-swiper');
          const memberTasksPrev = this.querySelector('.member-tasks_prev');
          const memberTasksNext = this.querySelector('.member-tasks_next');
          const $scrollbarDom = this.querySelector('.member-tasks-swiper-scrollbar');
          const swiper = new Swiper(memberTasksSwiper, {
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
              prevEl: memberTasksPrev,
              nextEl: memberTasksNext,
            },
            scrollbar: {
              el: $scrollbarDom,
              draggable: true,
            },
          });
        }
      }
    );
  }
});
